import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import ReactPlayer from "react-player";
import {connect} from "react-redux";

import {
    CardContainer,
    Notification,
    ActionSheet,
    ListItem,
    Player,
    Loading,
    ConfirmDialog,
    Image
} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';

import * as RouteService from 'services/route'
import {serverUrl, apiUrl} from 'services/network';
import {LevelApi} from 'services/network/api';
import {CircularProgress} from "@material-ui/core";


class Level extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            levelId: 0,
            userId: 0,
            data: undefined,
            text: '',
            actionSheetShow: false,
            actionSheetType: 'upload',
            loading: true,
            showConfirmDialog: false,
            confirmModalState: {},
            agreeBtnLoading: false,
            isPending: false,
            passed: false,
            sendLoading: false,
            expired: false
        };
    }

    componentDidMount() {
        this.getQsData();
    }

    getQsData() {
        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (!qs || !qs.levelId || !qs.userId) {
            Notification('error', 'WrongData');

            const {history} = this.props;
            history.goBack();
        }

        this.setState({levelId: qs.levelId, userId: qs.userId}, () => {
            this.loadData()
        });
    }

    loadData() {
        const {levelId, userId} = this.state;

        if (levelId && userId) {
            //TODO: Use loading
            LevelApi.GetAdminDetails(levelId, userId)
                .then(res => {
                    if (res && res.status == 200) {
                        const {data} = res;
                        const isPending = data.pending;
                        const passed = data.passed;
                        const expired = data.courseRegisterationType.toUpperCase() == 'EXPIRED';
                        this.setState({data: data.details, title: data.title, isPending, passed, expired});
                    }
                }).finally(() => {
                this.setState({loading: false});
            })
        }
    }

    _handleBubbles = (item) => {
        let {contentType, content, userType} = item;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

        const {locale} = this.props;
        const pageTranslates = locale.translation.Notifications;

        if (userType == 0 || userType == 1) {
            const userTypeClass = item.userType == 0 ? 'speech-left bg-highlight' : 'speech-right color-black';

            switch (contentType) {
                case 1:
                    content = item.content.split("\\n").map((text, i) => i ? [<br/>, text] : text);
                    return (
                        <>
                            <div className="clearfix"></div>
                            <div className={`speech-bubble ${userTypeClass}`}>
                                {content}
                            </div>
                        </>
                    );
                case 2:
                    const image = serverUrl + content;
                    return (
                        <>
                            <div className="clearfix"></div>
                            <div className={`speech-bubble speach-image ${userTypeClass}`}>
                                <Image src={image} style={{width: '100%', height: '100%', borderRadius: 20}}
                                       className="img-fluid preload-img"/>
                            </div>
                        </>
                    );
                case 3:
                    const url = `${apiUrl}/Media/Get?address=${content}`;

                    return (
                        <>
                            <div className="clearfix"></div>
                            <div className={`speech-bubble speach-image ${userTypeClass}`}>
                                <Player url={url}/>
                            </div>
                        </>
                    );
            }
        } else if (userType == 2) {
            if (contentType == 1)
                return (
                    <>
                        <div className="clearfix"></div>
                        <p className="text-center mb-0 font-11">{pageTranslates[content]}</p>
                    </>
                );
        }
    };

    _handleChangeText = (evt) => {
        this.setState({text: evt.target.value});
    };

    _handleTextSend = () => {
        const {text, levelId, userId, sendLoading} = this.state;
        if (text && levelId && userId && !sendLoading) {
            this.setState({sendLoading: true});
            const model = {text, levelId: parseInt(levelId), userId: parseInt(userId)};
            LevelApi.AdminText(model)
                .then(res => {
                    if (res && res.status == 200) {
                        let {data} = this.state;
                        data.push({contentType: 1, userType: 1, content: text});
                        this.setState({text: '', data});
                    }
                }).finally(x => {
                this.setState({sendLoading: false});
            });
        }
    };

    _handleSubmit = () => {
        this.setState({actionSheetShow: true, actionSheetType: 'submit'});
    };

    actionSheetCallback = (state) => {
        this.setState({actionSheetShow: state});
    };

    _handleImageUpload = (evt) => {
        const {levelId, userId} = this.state;
        const file = evt.target.files;
        if (file && levelId && userId) {
            this.setState({loading: true});

            let formData = new FormData();
            formData.append("LevelId", levelId);
            formData.append("UserId", userId);
            formData.append("ContentType", 2);
            formData.append("File", file[0]);

            //TODO: use loading or uploadProgress
            LevelApi.AdminUpload(formData)
                .then(res => {
                    if (res && res.status) {
                        let {data} = this.state;
                        data.push({contentType: 2, userType: 1, content: res.data.content});
                        this.setState({data});
                    }
                }).finally(() => {
                this.setState({actionSheetShow: false, loading: false});
            });
        }
    };

    _handleFilmUpload = (evt) => {
        const {levelId, userId} = this.state;
        const file = evt.target.files;
        if (file && levelId && userId) {
            this.setState({loading: true});

            let formData = new FormData();
            formData.append("LevelId", levelId);
            formData.append("UserId", userId);
            formData.append("ContentType", 3);
            formData.append("File", file[0]);

            //TODO: use loading or uploadProgress
            LevelApi.AdminUpload(formData)
                .then(res => {
                    if (res && res.status) {
                        let {data} = this.state;
                        data.push({contentType: 3, userType: 1, content: res.data.content});
                        this.setState({data});
                    }
                }).finally(() => {
                this.setState({actionSheetShow: false, loading: false});
            });
        }
    };

    ref = player => {
        this.player = player
    };

    _onAgreeConfirmDialog = () => {
        const {levelId, userId} = this.state;
        if (levelId, userId) {
            this.setState({agreeBtnLoading: true});
            LevelApi.SetAdminPending(levelId)
                .then(res => {
                    if (res && res.status == 200) {
                        this.setState({isPending: true});
                        Notification('success', 'SucceedSubmittedToReview');
                    }
                }).finally(() => {
                this.setState({agreeBtnLoading: false, showConfirmDialog: false});
            });
        }
    };

    _onCancelConfirmDialog = () => {
        this.setState({showConfirmDialog: false});
    };

    modalStateTypes() {
        const {locale} = this.props;
        const translate = locale.translation.Pages.Admin.Level.ModalTypes;

        const modalTypes = {
            approve: {
                title: translate.Approve.Title,
                content: translate.Approve.Content,
                func: this._approveLevel
            },
            disApprove: {
                title: translate.DisApprove.Title,
                content: translate.DisApprove.Content,
                func: this._disApproveLevel
            }
        };

        return modalTypes;
    }

    _handleFooter = () => {
        const {text, isPending, passed, sendLoading} = this.state;

        const {locale} = this.props;
        const translate = locale.translation.Pages.Admin.Level.Footer;

        if (passed) {
            const message = passed && translate.Done;
            return (
                <>
                    <div className="flex-fill speach-input">
                        <h6 className='text-center color-primary mt-3'>
                            {message}
                        </h6>
                    </div>
                </>
            );
        }

        return (
            <>
                <div className="mr-3 speach-icon">
                    <a className="bg-gray2-dark ml-2 speach-icon-link"
                       onClick={() => this.setState({actionSheetShow: true, actionSheetType: 'upload'})}><i
                        className="fa fa-plus"></i></a>
                </div>
                <div className="flex-fill speach-input mr-2">
                    <input type="text" className="form-control" onChange={this._handleChangeText}
                           value={text}
                           placeholder={translate.PlaceHolder}/>
                </div>
                <div className="ml-2 speach-icon">
                    <a className="bg-blue2-dark mr-2 speach-icon-link" onClick={this._handleTextSend}>
                        <i className="fa fa-arrow-up"></i>
                    </a>
                </div>
                <div className="ml-3 speach-icon">
                    <a className="bg-green2-dark mr-2 speach-icon-link" onClick={this._handleSubmit}>
                        <i className="fa fa-check"></i></a>
                </div>
            </>
        );
    };

    _handleActionSheetFunc = () => {
        const {actionSheetType} = this.state;

        const {locale} = this.props;
        const translate = locale.translation.Pages.Admin.Level;

        switch (actionSheetType.toLowerCase()) {
            case 'upload':
                return (
                    <>
                        <h5 className='text-center'>
                            {translate.UploadContent}
                        </h5>

                        <div className="list-group list-custom-small">
                            <a className='list-item-style' onClick={() => {
                                global.document.getElementById('browseImageFileButton').click();
                            }}>
                                <div className='selectFileButton' className='float-right d-flex align-items-center'>
                                    <i className='rounded-sm shadow-xl bg-primary'
                                       style={{fontStyle: 'normal', marginTop: 0}}>
                                        <p className={`fa fa-image`} style={{fontSize: 13, color: 'black'}}></p>
                                    </i>
                                    <input
                                        id="browseImageFileButton"
                                        type="file"
                                        accept="image/*"
                                        onChange={this._handleImageUpload}
                                        hidden
                                    />
                                    <span>
                                        {translate.ContentTypes.Image}
                                    </span>
                                </div>
                                <i className="fa fa-angle-left"></i>
                            </a>
                            <a className='list-item-style' onClick={() => {
                                global.document.getElementById('browseFilmFileButton').click();
                            }}>
                                <div className='selectFileButton' className='float-right d-flex align-items-center'>
                                    <i className='rounded-sm shadow-xl bg-primary'
                                       style={{fontStyle: 'normal', marginTop: 0}}>
                                        <p className={`fa fa-film`} style={{fontSize: 13, color: 'black'}}></p>
                                    </i>
                                    <input
                                        id="browseFilmFileButton"
                                        type="file"
                                        accept="video/mov, video/3g2, video/3gp, video/3gp2, video/3gpp, video/asf, video/asx, video/avi, video/divx, video/m4v,  video/mp4, video/mpe, video/x-m4v, video/mpeg, video/mpg, video/ogg, video/wmv"
                                        onChange={this._handleFilmUpload}
                                        hidden
                                    />
                                    <span>
                                        {translate.ContentTypes.Movie}
                                    </span>
                                </div>
                                <i className="fa fa-angle-left"></i>
                            </a>
                        </div>
                    </>
                );
            case 'submit':
                return (
                    <>
                        <h5 className='text-center'>
                            {translate.SubmitContent}
                        </h5>

                        <div className="list-group list-custom-small">
                            <a className='list-item-style d-flex justify-content-between align-items-center'
                               onClick={this._handleApproveLevel}>
                                <div className='d-flex align-items-center'>
                                    <i className='rounded-sm shadow-xl bg-success fa fa-check text-white'
                                       style={{fontStyle: 'normal', marginTop: 0}}>
                                    </i>
                                    <div className='selectFileButton' style={{float: 'right'}}>
                                        <span>
                                            {translate.Approve}
                                        </span>
                                    </div>
                                </div>
                                <i className="fa fa-angle-left"></i>
                            </a>
                            <a className='list-item-style d-flex justify-content-between align-items-center'
                               onClick={this._handleDisApproveLevel}>
                                <div className='d-flex align-items-center'>
                                    <i className='rounded-sm shadow-xl bg-danger fa fa-times text-white'
                                       style={{fontStyle: 'normal', marginTop: 0}}>
                                    </i>
                                    <div className='selectFileButton' style={{float: 'right'}}>
                                        <span>
                                            {translate.DisApprove}
                                        </span>
                                    </div>
                                </div>
                                <i className="fa fa-angle-left"></i>
                            </a>
                        </div>
                    </>
                );
        }
    };

    _handleApproveLevel = () => {
        const modalTypes = this.modalStateTypes();
        this.setState({showConfirmDialog: true, confirmModalState: modalTypes.approve});
    };

    _handleDisApproveLevel = () => {
        const modalTypes = this.modalStateTypes();
        this.setState({showConfirmDialog: true, confirmModalState: modalTypes.disApprove});
    };

    _approveLevel = () => {
        const {levelId, userId} = this.state;

        this.setState({agreeBtnLoading: true});
        if (levelId && userId) {
            LevelApi.SetAdminPending(levelId, userId, true)
                .then(res => {
                    if (res.status == 200) {
                        this.loadData();
                        Notification('success', 'Succeed');
                    }
                })
                .finally(() => {
                    this.setState({agreeBtnLoading: false, actionSheetShow: false, showConfirmDialog: false});
                });
        }
    };

    _disApproveLevel = () => {
        const {levelId, userId} = this.state;

        this.setState({agreeBtnLoading: true});
        if (levelId && userId) {
            LevelApi.SetAdminPending(levelId, userId, false)
                .then(res => {
                    if (res.status == 200) {
                        this.loadData();
                        Notification('success', 'Succeed');
                    }
                })
                .finally(() => {
                    this.setState({agreeBtnLoading: false, actionSheetShow: false, showConfirmDialog: false});
                });
        }
    };

    render() {
        const {title, data, text, actionSheetShow, loading, showConfirmDialog, confirmModalState, agreeBtnLoading, isPending, expired} = this.state;

        if (loading)
            return <Loading/>;

        if (!data || data.length == 0)
            return (<NoRecord message='Level'/>);

        return (
            <>
                <CardContainer>
                    {expired &&
                    <div className="alert m-2 rounded-s bg-red2-dark mb-3" role="alert">
                        <small className="alert-icon-text text-center">
                            User has expired in this course
                        </small>
                    </div>
                    }
                    <h3 className='color-primary pb-2'>
                        {title}
                    </h3>
                    <div>
                        {data.map(item => {
                            return this._handleBubbles(item);
                        })}
                    </div>
                </CardContainer>

                <div id="footer-bar" className="d-flex footer-bar-action safe-area-view-bottom" style={{zIndex: 99}}>
                    {this._handleFooter()}
                </div>

                <ActionSheet show={actionSheetShow} callback={this.actionSheetCallback} hasClose>
                    {this._handleActionSheetFunc()}
                </ActionSheet>

                <ConfirmDialog open={showConfirmDialog} title={confirmModalState.title}
                               content={confirmModalState.content}
                               onAgree={confirmModalState.func} onCancel={this._onCancelConfirmDialog}
                               agreeLoading={agreeBtnLoading}/>
            </>
        )
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Level));